/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */

export type SocialRegister403Code = typeof SocialRegister403Code[keyof typeof SocialRegister403Code];


export const SocialRegister403Code = {
  PUBLIC_DOMAIN_RESTRICTED: 'PUBLIC_DOMAIN_RESTRICTED',
} as const;
